import React from 'react'
import imgPhone from "../../../assets/img/costcall/1/phone.png";
import img1 from "../../../assets/img/costcall/1/1.png";
import img2 from "../../../assets/img/costcall/1/2.png";
import classes from "./Seventh.module.scss"

const Seventh = () => {
    return (
        <div className={[classes.first, "pt pb"].join(" ")}>
            <div className={[classes.firstBody, ""].join(" ")}>
                <div className="container">
                    <div className={[classes.firstContent, ""].join(" ")}>
                        <div className={[classes.firstContentLeft, ""].join(" ")}>
                            <div className={[classes.firstContentLeftTitle, "font-40"].join(" ")}>
                                Получите еще больше  выгоды с Bomber VPN
                            </div>
                            <div className={[classes.firstContentLeftDecor, "decor"].join(" ")}>
                                <span></span><span></span><span></span>
                            </div>
                            <div className={[classes.firstContentLeftList, ""].join(" ")}>
                                <p className={[classes.firstContentLeftListItem, ""].join(" ")}>
                                    Неограниченный трафик
                                </p>
                                <p className={[classes.firstContentLeftListItem, ""].join(" ")}>
                                    Доступ к премиум локациям
                                </p>
                            </div>

                            <div className={[classes.firstContentLeftBottom, ""].join(" ")}>
                                <a href='#' className={[classes.firstContentLeftBottomItem, ""].join(" ")}>
                                    <img src={img1} alt="" />
                                    <div className={[classes.firstContentLeftBottomItemWrap, ""].join(" ")}>
                                        <span>Скачать в </span>
                                        <span>Google play</span>
                                    </div>
                                </a>
                                <a href='#' className={[classes.firstContentLeftBottomItem, ""].join(" ")}>
                                    <img src={img2} alt="" />
                                    <div className={[classes.firstContentLeftBottomItemWrap, ""].join(" ")}>
                                        <span>Скачать в </span>
                                        <span>APPLE STORE</span>
                                    </div>


                                </a>
                            </div>


                        </div>
                        <div className={[classes.firstContentRight, ""].join(" ")}>
                            <img src={imgPhone} alt="" />
                        </div>

                    </div>

                </div>
            </div>

        </div>

    )
}

export default Seventh